import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { StyledBaseCell, StyledContactNameText } from "./styles";

interface IProps {
    value: string;
}

const ContactDepartmentCell = ({ value }: IProps): ReactElement => {
    return (
        <StyledBaseCell>
            {value ? (
                <StyledContactNameText
                    fontVariant="value"
                    color={colorsPalettes.carbon[400]}
                >
                    {value}
                </StyledContactNameText>
            ) : null}
        </StyledBaseCell>
    );
};

export default ContactDepartmentCell;
